import { useState } from "react"

export function useList() {
  const [list, setList] = useState([])

  const listHasItem = (item) => list.includes(item)

  const toggleItem = (item) => {
    if (listHasItem(item)) {
      return setList((prev) => prev.filter((i) => i !== item))
    }
    return setList((prev) => prev.concat(item))
  }
  const resetList = () => setList([])
  const appendItem = (item) => setList((prev) => prev.concat(item))

  return [
    list,
    { listHasItem, toggleItem, clear: resetList, append: appendItem },
  ]
}
